import React from 'react';
import loadable from '@loadable/component';
import config from '../../config';
import Preloader from '../../components/Preloader';

const SettingsMainPage = loadable(
  () => import(
    /* webpackChunkName: "settings-main-page-chunk" */
    './SettingsMainPage'
  ),
  {
    fallback: (
      <Preloader isDefault={config.isCustomApp} />
    ),
  }
);

export default SettingsMainPage;
